/**
 * Home Feature i18n Registration
 * 将本模块的语言包注册到全局 i18n 实例
 */

import { addLocaleMessages } from '@/i18n';
import '@/components/source-render/rejection-table/rejection-hierarchy-i18n';
import zhCN from './locales/zh-CN';
import zhTW from './locales/zh-TW';
import enUS from './locales/en-US';
import jaJP from './locales/ja-JP';

// 注册简体中文语言包
addLocaleMessages('cn', zhCN);

// 注册繁体中文语言包
addLocaleMessages('tw', zhTW);

// 注册英文语言包
addLocaleMessages('en', enUS);

// 注册日文语言包
addLocaleMessages('jp', jaJP);
